var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick - filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 21C17.5527 21 21.75 16.8027 21.75 11.625C21.75 6.44734 17.5527 2.25001 12.375 2.25001C7.19733 2.25001 3 6.44734 3 11.625C3 16.8027 7.19733 21 12.375 21ZM18.2344 8.50001C18.5481 8.79627 18.5622 9.29073 18.2659 9.60441L11.7711 16.0677C11.6262 16.2211 11.4253 16.3094 11.2143 16.3124C11.0032 16.3154 10.7999 16.2329 10.6507 16.0837L6.74445 12.1774C6.43935 11.8723 6.43935 11.3777 6.74445 11.0726C7.04954 10.7675 7.54421 10.7675 7.8493 11.0726L11.1871 14.4104L17.13 8.53156C17.4262 8.21788 17.9207 8.20375 18.2344 8.50001Z",
    fill: "#0BAA4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFilled);
export default __webpack_public_path__ + "static/media/tick-filled.60f0bb9c985d078d5bd84ac3532b53df.svg";
export { ForwardRef as ReactComponent };